module.exports = __webpack_public_path__ + "static/background/toubao_bg@2x.png";